// extracted by mini-css-extract-plugin
export default {"markdown":"AssistantMarkdown_markdown__5eVDG","tableScroll":"AssistantMarkdown_tableScroll__91Kis"};